/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EsgTickets } from '../../models/esg-tickets';
import { EsgTicketUpsert } from '../../models/esg-ticket-upsert';

export interface EsgTicketBatchUpsertForEsg$Plain$Params {
  profileId: number;
  year: number;
  code: string;
      body?: Array<EsgTicketUpsert>
}

export function esgTicketBatchUpsertForEsg$Plain(http: HttpClient, rootUrl: string, params: EsgTicketBatchUpsertForEsg$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<EsgTickets>> {
  const rb = new RequestBuilder(rootUrl, esgTicketBatchUpsertForEsg$Plain.PATH, 'post');
  if (params) {
    rb.path('profileId', params.profileId, {});
    rb.path('year', params.year, {});
    rb.path('code', params.code, {});
    rb.body(params.body, 'text/plain');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EsgTickets>;
    })
  );
}

esgTicketBatchUpsertForEsg$Plain.PATH = '/esg/profile/{profileId}/esg/{year}/{code}/ticket';
